import { useState } from 'react'
import AdminUserList from './AdminUserList'
import AdminUserDetail from './AdminUserDetail'
import AdminManagement from './AdminManagement'

export default function AdminDashboard({ admin, onLogout }) {
  const [selectedUser, setSelectedUser] = useState(null)
  const [page, setPage] = useState('users')
  const [lang, setLang] = useState('en')

  const t = (en, zh) => lang === 'zh' ? zh : en

  return (
    <div style={{ minHeight: '100vh', background: '#f3f4f6' }}>
      {/* 顶部导航 */}
      <div style={{ background: '#1e293b', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '56px', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ color: '#fff', fontWeight: '600', fontSize: '15px' }}>FinconnectX Admin</span>

          {/* 导航菜单 */}
          <div style={{ display: 'flex', marginLeft: '16px', gap: '2px' }}>
            {[
              { key: 'users', label: t('Users', '用户管理') },
              admin.permissions?.can_manage_admins && { key: 'admins', label: t('Admins', '管理员') },
            ].filter(Boolean).map(item => (
              <button key={item.key} onClick={() => { setPage(item.key); setSelectedUser(null) }}
                style={{ padding: '6px 14px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: '500', background: page === item.key ? '#3b82f6' : 'transparent', color: page === item.key ? '#fff' : '#94a3b8', transition: 'all .15s' }}>
                {item.label}
              </button>
            ))}
          </div>

          {/* 面包屑 */}
          {selectedUser && (
            <span style={{ color: '#475569', fontSize: '13px' }}>
              / <button onClick={() => setSelectedUser(null)} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', fontSize: '13px', padding: '0 4px' }}>
                {t('Users', '用户列表')}
              </button>
              / <span style={{ color: '#94a3b8' }}>{selectedUser.user_number_text}</span>
            </span>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ display: 'flex', gap: '2px', background: '#334155', borderRadius: '6px', padding: '3px' }}>
            {['en', 'zh'].map(l => (
              <button key={l} onClick={() => setLang(l)}
                style={{ padding: '4px 10px', borderRadius: '4px', border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: '500', background: lang === l ? '#fff' : 'transparent', color: lang === l ? '#1e293b' : '#94a3b8' }}>
                {l === 'en' ? 'EN' : '中文'}
              </button>
            ))}
          </div>
          <span style={{ color: '#94a3b8', fontSize: '13px' }}>👤 {admin.name}</span>
          <button onClick={onLogout}
            style={{ background: 'none', border: '1px solid #475569', color: '#94a3b8', borderRadius: '6px', padding: '5px 12px', cursor: 'pointer', fontSize: '12px' }}>
            {t('Logout', '登出')}
          </button>
        </div>
      </div>

      {/* 主内容 */}
      <div style={{ padding: '24px' }}>
        {page === 'users' && !selectedUser && (
          <AdminUserList admin={admin} onSelectUser={setSelectedUser} lang={lang} />
        )}
        {page === 'users' && selectedUser && (
          <AdminUserDetail user={selectedUser} admin={admin} onBack={() => setSelectedUser(null)} lang={lang} />
        )}
        {page === 'admins' && (
          <AdminManagement admin={admin} lang={lang} />
        )}
      </div>
    </div>
  )
}